import React from 'react';
import { injectIntl } from 'react-intl';
import { PrintActionButton } from '../../../components/sub-header/actions/PrintActionButton';
import { ShareActionButton } from '../../../components/sub-header/actions/ShareActionButton';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { detectUserAgent } from '../../../utils/userAgentUtils';
import { withUser } from '../../../user/UserContext';
import { UserContextType } from '../../../user/user.types';
import { InjectedIntlProps } from '../../../doctrine.types';

type Props = {
  name: string;
  source: string;
} & UserContextType &
  InjectedIntlProps;

export function RawEnterpriseActions({
  accessPremium,
  name,
  source,
  intl,
}: Props) {
  const textToCopy = () => {
    const enterpriseUrl = `${window.location.origin}${window.location.pathname}`;
    return intl.formatMessage(
      { id: 'app.pages.enterprise.header.copy' },
      { name, enterpriseUrl },
    );
  };

  const sendPrintAnalytics = () =>
    doctrineAnalytics('Enterprise ButtonPrintClicked');

  const sendShareAnalytics = () =>
    doctrineAnalytics('Enterprise ButtonCopyClicked');

  return (
    <div className="button-group no-gaps clear secondary">
      {detectUserAgent() !== 'Mozilla Firefox' && (
        <PrintActionButton
          accessPremium={accessPremium}
          sendAnalytics={sendPrintAnalytics}
          source={source}
        />
      )}
      <ShareActionButton
        text={textToCopy()}
        sendAnalytics={sendShareAnalytics}
        source={source}
      />
    </div>
  );
}

export const EnterpriseActions = withUser(injectIntl(RawEnterpriseActions));
